
import styles from './advantegesSection.module.css';
import { Advantage } from '../../../ui/advantage/Advantage';
import { advantagesItems } from '../../../../constants/aboutUsPage/advantagesItems';

export function AdvantagesSection() {
  return (
    <div className={styles.mainContainer}>
      {advantagesItems?.map((advantage) => {
        return (
          <Advantage
            image={advantage.image}
            text={advantage.text}
            description={advantage.description}
          />
        );
      })}
    </div>
  );
}
